import type { Episode, Podcast } from '~/types/podcast';

interface Player {
    play(episode: Episode, podcast: Podcast, currentSeek: number): void;
}

interface Progress {
    currentSeek: number;
}

export function playLatestEpisode(
    episode: Episode | undefined,
    podcast: Podcast,
    player: Player,
    getProgress: (episode: Episode, podcastId: string) => Progress,
): boolean {
    if (!episode) {
        return false;
    }

    player.play(episode, podcast, getProgress(episode, podcast.itunes_id).currentSeek);

    return true;
}
